import EmblaCarousel from "embla-carousel";

function initCustomizationCarousel() {
	const wrapperNode = document.querySelector(
		".customization-carousel"
	) as HTMLElement;

	if (!wrapperNode) return;

	const viewportNode = wrapperNode.querySelector(
		".customization-carousel__viewport"
	) as HTMLElement;
	const prevButtonNode = wrapperNode.querySelector(
		".customization-carousel__prev"
	) as HTMLButtonElement;
	const nextButtonNode = wrapperNode.querySelector(
		".customization-carousel__next"
	) as HTMLButtonElement;
	const dotsContainer = wrapperNode.querySelector(
		".customization-carousel__dots"
	);
	const captions = wrapperNode.querySelectorAll(
		".customization-carousel__caption"
	);

	const emblaApi = EmblaCarousel(viewportNode, {
		loop: true,
		align: "center",
	});

	// Create dot buttons
	const slides = emblaApi.slideNodes();
	slides.forEach((_, index) => {
		const dot = document.createElement("button");
		dot.className = "customization-carousel__dot";
		dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
		dot.addEventListener("click", () => emblaApi.scrollTo(index));
		dotsContainer?.appendChild(dot);
	});

	const dots = dotsContainer?.querySelectorAll(".customization-carousel__dot");

	function updateDots() {
		const selectedIndex = emblaApi.selectedScrollSnap();
		dots?.forEach((dot, index) => {
			dot.classList.toggle("is-selected", index === selectedIndex);
		});
	}

	function updateCaptions() {
		const selectedIndex = emblaApi.selectedScrollSnap();
		captions.forEach((caption, index) => {
			(caption as HTMLElement).style.display =
				index === selectedIndex ? "block" : "none";
		});
	}

	// Navigation buttons
	prevButtonNode?.addEventListener("click", () => emblaApi.scrollPrev(), false);
	nextButtonNode?.addEventListener("click", () => emblaApi.scrollNext(), false);

	// Image click to open full size (use src which Parcel transforms)
	const images = wrapperNode.querySelectorAll(".customization-carousel__image");
	images.forEach((img) => {
		img.addEventListener("click", (e) => {
			const target = e.currentTarget as HTMLImageElement;
			window.open(target.src, "_blank");
		});
	});

	// Update on select
	emblaApi.on("select", () => {
		updateDots();
		updateCaptions();
	});

	// Initial state
	updateDots();
	updateCaptions();
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initCustomizationCarousel);
} else {
	initCustomizationCarousel();
}
